import Nullstack from 'nullstack';
export default function IconSunglasses({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sunglasses",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h-2l-3 10"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2l3 10"
  }), "   ", Nullstack.element("path", {
    d: "M10 16h4"
  }), "   ", Nullstack.element("path", {
    d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 14l4.5 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 14l4.5 4.5"
  }), " ");
}